module.exports = __webpack_public_path__ + "media/tone.fdf5c682.mp3";